import axios from 'axios'
import { observer } from 'mobx-react'
import React, { memo, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import { apiUrl } from '../../config'
import DashboardLayout from '../../layouts/DashboardLayout'
import authenticationStore from '../../stores/authenticationStore'

const BiPage = props => {
  const [linkBi, setLinkBi] = useState('')

  useEffect(() => {
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/info-option/MISBI`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    })
      .then(res => setLinkBi(res.data?.value || ''))
      .catch(() => setLinkBi(''))
  }, [])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Báo cáo hoạt động SXKD</title>
      </Helmet>
      <PageTitle
        location={props.location}
        title={'Báo cáo hoạt động sản xuất kinh doanh'}
        hiddenGoBack
      />
      <ContentBlockWrapper styles={{ height: '100%' }}>
        {linkBi && (
          <iframe
            title="BÁO CÁO HOẠT ĐỘNG SẢN XUẤT KINH DOANH"
            width="100%"
            height="800"
            src={linkBi}
            frameBorder={0}
            allowFullScreen={true}
          />
        )}
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

BiPage.propTypes = {}

export default memo(observer(BiPage))
